export const initialWidgetFilters = {
  qualityTracking: [{ filter_parameter: "status__in", filter_value: "W,I" }],
};
